import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import Buscando from 'Component/Admin/Buscando';
import Cabecalho from 'Component/Admin/Cabecalho';
import { PlanoLista } from 'Component/Admin/Plano';
import SemRegistros from 'Component/Admin/SemRegistros';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Form, { Campo } from 'Component/Form';
import Paginacao from 'Component/Paginacao';
import Parametros from 'Interface/Requisicao';
import { useRecuperarPlanosQuery } from 'Service';

const regras = object({
    busca: string().optional().min(3, 'Deve ter mais que 3 letras'),
});

const Default = (): React.ReactElement =>
{
    const [ searchParams, setSearchParams ] = useSearchParams();
    const { data, refetch, isFetching, isLoading } = useRecuperarPlanosQuery({
        page: searchParams.get('pagina') || 1,
        options: { busca: { termo: searchParams.get('busca') || '' } },
    } as Parametros);

    const filtrar = (dados: { busca: string }, form: FormikHelpers<FormikValues>) =>
    {
        searchParams.set('busca', dados.busca);

        setSearchParams(searchParams);

        form.setSubmitting(false);
    }

    return (
        <div className="animate__animated animate__fadeIn">
            <Cabecalho
                titulo="Planos"
                descricao="Listagem de planos cadastrados no banco de dados"
            />
            <Form
                emLinha
                onSubmit={ filtrar }
                regras={ regras }
                desabilitado={ isFetching }
            >
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <Botao icone="arrow-clockwise" onClick={ refetch } />
                        <BotaoLink
                            tema="success"
                            icone="plus-lg"
                            to="/admin/planos/adicionar"
                            className="ms-2"
                        >
                            Adicionar
                        </BotaoLink>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="hstack gap-3">
                            <Campo name="busca" rotulo="Digite o que deseja bucar" semMargem />
                            <Botao type="submit" icone="filter" />
                        </div>
                    </div>
                </div>
            </Form>
            <Buscando exibir={ isLoading } />
            <SemRegistros
                carregando={ isLoading }
                registros={ data?.planos.length }
                redirecionar="/admin/planos/adicionar"
            />
            <div className="bg-white shadow-sm rounded">
                {data?.planos?.map(plano => (
                    <PlanoLista
                        key={ `${plano.id}-${plano.modificado}` }
                        dados={plano}
                    />
                ))}
            </div>
            <Paginacao
                dados={ data?.paginacao }
                desabilitado={ isFetching }
            />
        </div>
    )
}

export default Default;
